import "./publicIndex.49ec285b.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e3e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e3e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hicRY", function(module, exports) {
module.exports = import.meta.resolve("kT3Io");

});


var $1Ivrw = parcelRequire("1Ivrw");

var $7kdoE = parcelRequire("7kdoE");
var $8B0OW = parcelRequire("8B0OW");

var $aqdBs = parcelRequire("aqdBs");

var $hgBo9 = parcelRequire("hgBo9");


var $1Ivrw = parcelRequire("1Ivrw");

var $cuxbp = parcelRequire("cuxbp");

var $fbVeO = parcelRequire("fbVeO");

var $itEVn = parcelRequire("itEVn");

var $hYtyw = parcelRequire("hYtyw");

var $hoNHR = parcelRequire("hoNHR");

var $6XMC4 = parcelRequire("6XMC4");

var $gIVfe = parcelRequire("gIVfe");

var $1Ivrw = parcelRequire("1Ivrw");
parcelRequire("aqdBs");

var $cilzt = parcelRequire("cilzt");

var $1TwnN = parcelRequire("1TwnN");
const $28948bb6ea1858f1$export$da4433e8d8a5678 = (props)=>{
    return /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
        className: "h-screen w-screen bg-login-art bg-cover md:pt-[10vh]",
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1TwnN.CardContainer), {
            variant: "flex",
            className: "items-center justify-center",
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cilzt.ResetPasswordCard), {
                mode: props.mode
            })
        })
    });
};



var $3hlzj = parcelRequire("3hlzj");

var $8tyA9 = parcelRequire("8tyA9");

var $1Ivrw = parcelRequire("1Ivrw");

var $cuxbp = parcelRequire("cuxbp");

var $3hlzj = parcelRequire("3hlzj");

var $1Ivrw = parcelRequire("1Ivrw");

var $hicRY = parcelRequire("hicRY");
parcelRequire("aqdBs");

var $k2eQl = parcelRequire("k2eQl");

var $cuxbp = parcelRequire("cuxbp");
const $bb5d2e56730ad760$export$5b80f1d387c28dff = ()=>{
    const navigate = (0, $cuxbp.useNavigate)();
    const handleChange = ()=>{
        navigate('/login');
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
        className: "flex h-screen justify-center w-full",
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)("div", {
            className: "flex flex-col flex-wrap self-center w-[300px] md:w-[440px]",
            children: [
                /*#__PURE__*/ (0, $1Ivrw.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($hicRY))),
                    alt: "",
                    className: "mb-6 w-40"
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                    className: "font-semibold mt-6",
                    children: "Your email has been verified!"
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)("p", {
                    className: "text-left mt-6",
                    children: "Use your email address and the temporary password you received to sign in."
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $k2eQl.Button), {
                    type: "submit",
                    onClick: handleChange,
                    className: "w-full bg-primaryButtonColor text-white mt-6",
                    children: "Go to sign in"
                })
            ]
        })
    });
};



var $cZTdw = parcelRequire("cZTdw");

var $7wklC = parcelRequire("7wklC");

var $aqdBs = parcelRequire("aqdBs");
const $013b5eb966c8bb1d$export$3d3197b723615cc = ()=>{
    const [params] = (0, $cuxbp.useSearchParams)();
    const token = params.get('token');
    const { isError: isError, isSuccess: isSuccess, mutate: mutate } = (0, $cZTdw.useApiVerifyEmail)();
    (0, $aqdBs.useEffect)(()=>{
        mutate(token);
    }, []);
    console.log('isSuccess', isSuccess);
    console.log('isError', isError);
    return isSuccess ? /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $bb5d2e56730ad760$export$5b80f1d387c28dff), {}) : isError ? /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3hlzj.TokenExpiredPage), {}) : /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $7wklC.CenteredSpinner), {});
};


const $1b54cff01a52a60f$var$router = (0, $cuxbp.createBrowserRouter)([
    {
        path: '/login',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $hoNHR.LoginPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/forgot_pw',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $itEVn.ForgotPasswordPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/pw_resetted',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $hYtyw.PasswordResetedPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/maintenance/verify_email',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $013b5eb966c8bb1d$export$3d3197b723615cc), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/ftu',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fbVeO.FTUPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/verify',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $6XMC4.VerifyPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/reset_password',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $28948bb6ea1858f1$export$da4433e8d8a5678), {
            mode: "resetPassword"
        }),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/password_changed',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $gIVfe.PasswordChangedPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/token_expired',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3hlzj.TokenExpiredPage), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/user_maintenance_complete',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cuxbp.Navigate), {
            to: "/"
        }),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/enable_account',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $28948bb6ea1858f1$export$da4433e8d8a5678), {
            mode: "enableUser"
        }),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    //not 100% sure if anything anymore routes to these pages from back end but doesnt cost us anything to have these mapped here
    {
        path: '/error',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    },
    {
        path: '/access_denied',
        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {}),
        errorElement: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8tyA9.default), {})
    }
]);
const $1b54cff01a52a60f$export$1f1b40e96be620a0 = ()=>/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cuxbp.RouterProvider), {
        router: $1b54cff01a52a60f$var$router
    });



var $jBgAQ = parcelRequire("jBgAQ");

var $1UiJ5 = parcelRequire("1UiJ5");

var $h799M = parcelRequire("h799M");
/// <reference types="../react-app-env.d.ts" />
const $e56e9e6e431bdbf3$var$queryClient = new (0, $7kdoE.QueryClient)();
//set OpenAPI base url empty so that requests are send to relative url and not the local host where api docs where generated
(0, $jBgAQ.OpenAPI).BASE = '';
Array.from(document.getElementsByClassName('react')).forEach((el)=>{
    if (el) {
        const root = (0, (/*@__PURE__*/$parcel$interopDefault($hgBo9))).createRoot(el);
        root.render(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).StrictMode, {
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8B0OW.QueryClientProvider), {
                client: $e56e9e6e431bdbf3$var$queryClient,
                children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $h799M.OverlayProvider), {
                    children: [
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1UiJ5.Toaster), {
                            position: "bottom-right",
                            toastOptions: {
                                duration: 5000
                            }
                        }),
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $h799M.Overlay), {}),
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1b54cff01a52a60f$export$1f1b40e96be620a0), {})
                    ]
                })
            })
        }));
    }
});


//# sourceMappingURL=publicIndex.1496ce25.js.map
